document.addEventListener('DOMContentLoaded', () => {

   // Open modal when clicking on images
   let modalOpeners = document.querySelectorAll('modal-opener');
   modalOpeners.forEach(function (modalOpener) {
     modalOpener.addEventListener('click', (e) => {
       modalOpener.querySelector(".product__media-toggle").click();
     });
   });
   
   const thumbnails = document.querySelectorAll(".thumbnail");
   if (thumbnails) {
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener("click", (event) => {
          window.scrollTo({top: 0, behavior: 'smooth'});
        });
      });
   }
   
   let downloadPDFLink = document.querySelector(".downloadPDF");
   if (downloadPDFLink) {
    downloadPDFLink.addEventListener('click', (e) => {
        e.preventDefault();
        var url = downloadPDFLink.getAttribute("href")  
        downloadPDFfile(url);
      })   
    }
    //Product warning image 
  
    let productWarning = document.querySelector("[data-warning-image-toggle]");
    let productWarningImage = document.querySelector("[data-warning-image-container]");

    if (productWarning) {
        productWarning .addEventListener('click', function(){
          productWarningImage.classList.add('active');
        });

        productWarningImage.addEventListener('click', function (){
          productWarningImage.classList.remove('active');
        });
    }

    // Make all product accordions closed on mobile by default
    if (window.innerWidth < 822) {

      // Remove zooming on mobile
      document.querySelectorAll(".zoomimg").forEach(function(image) {
        image.classList.remove("zoomimg")
      });
      
    }

   //foursixty images 
    if (document.querySelector(".fs-hidden-slider")){
        waitFoursixtyImages();  
    }
});

function waitFoursixtyImages() {
 
  return new Promise(resolve => {
      const observer = new MutationObserver(mutations => {
      let images_loaded ;
      let images_counter = 0;
      let foursixtyImages = document.querySelectorAll(".fs-entry-container .fs-timeline-entry");
      foursixtyImages.forEach(function(slide) {
        const computedStyle = window.getComputedStyle(slide);
        const backgroundImage = computedStyle.getPropertyValue("background-image");
        if(computedStyle){
            if (backgroundImage.indexOf("://") > -1) {
                  images_loaded =true;
                  images_counter = images_counter + 1;
            }
            else 
                images_loaded =false;
        }
     }); 
        if (images_loaded && images_counter == foursixtyImages.length) {
          if (images_counter > 3)
             images_counter = 3;

          for (let i = 0; i < images_counter ; i++) {
            let img_url = window.getComputedStyle(foursixtyImages[i]).getPropertyValue("background-image").replace('url(','').replace(')','').replace(/"/gi, "");
            var fs_thumbnail=
            `<li id="Slide-Thumbnails-fs`+i+`" class="thumbnail-list__item slider__slide fs__thumbnail" data-target="fs`+i+`" data-media-position="i">
              <button class="thumbnail global-media-settings global-media-settings--no-shadow thumbnail--narrow" aria-controls="GalleryViewer-template--15931987132596__main" aria-describedby="Thumbnail-fs`+i+`">
                <img id="Thumbnail-fs`+i+`"
                src="`+img_url + `" alt="Foursixty thumbnail" height="200" width="200" >
              </button>
            </li>`;
            
            var fs_img = 
            `<li id="Slide-fs`+i+`" class="product__media-item grid__item slider__slide fs__image fs__image-`+i+`" data-media-id="fs`+i+`">
               <div class="product__media media gradient global-media-settings" style="padding-top: 0;">
                  <img src="`+img_url + `" width="973" height="973" alt="Foursixty image">
               </div> 
            </li>`;
            
            document.querySelector(".thumbnail-list").insertAdjacentHTML("beforeend", fs_thumbnail);
            document.querySelector(".product__media-list").insertAdjacentHTML("beforeend", fs_img)


            let fs_thumbnails = document.querySelectorAll('.fs__thumbnail');
            let fs_images = document.querySelectorAll('.fs__image');
            let fs_elements = document.querySelectorAll(".fs-timeline-entry")

            for (let i = 0; i < fs_thumbnails.length ; i++) {
            let fs_image = document.querySelector('.fs__image-'+i)
              fs_thumbnails[i].addEventListener('click', function(){
                   fs_elements[i].click(); 
                    document.querySelector('.is-active').classList.remove('is-active');
                    fs_image.classList.add('is-active');
              });

              fs_images[i].addEventListener('click', function(){
                fs_elements[i].click();   
             });

            }  

            observer.disconnect();
          }
        }
                 
    });
    observer.observe(document.querySelector(".fs-hidden-slider"), {
      childList: true,
      subtree: true,
      attributes:true
    });                        
  });
}

function downloadPDFfile(url){
   fetch(url)
   .then(resp => resp.blob())
   .then(blob => {
       const url = window.URL.createObjectURL(blob);
       const a = document.createElement('a');
       a.style.display = 'none';
       a.href = url;
       //  filename name
       var url_split = url.split("/");
       var name = url_split[url_split.length - 1];
       a.download = name;
       document.body.appendChild(a);
       a.click();
       window.URL.revokeObjectURL(url);
   })
   .catch(() => alert('An error'));
}

/* FTC-2417-5 Sticky media gallery on PDP Desktop */
function addingTopStickyGallery() {
  let stickyHeader = document.querySelector('#header-announcement-container');
  let mediaGallery = document.querySelector('.product media-gallery');
  mediaGallery.style.top = stickyHeader.offsetHeight + "px";;  
}

/* FTC-2286 Sticky PDP add to cart button on mobile */
function getElementPositionFromTop(element) {
  let position = 0;
  while (element) {
    position += element.offsetTop;
    element = element.offsetParent;
  }
  return position;
}
function handleScroll() {
  let className = 'quantity-and-button-wrapper';
  let element = document.querySelector('.' + className);
  let positionFromTop = getElementPositionFromTop(element);
  let viewportHeight = window.innerHeight;
  let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  if (element) {
    
    if (scrollPosition > viewportHeight * 0.5) {
      element.classList.add('scrolled-past');
      document.querySelector('body').classList.add('fixed-buttons');
    } else {
      element.classList.remove('scrolled-past');
      document.querySelector('body').classList.remove('fixed-buttons');
    }
  }
}
function addingParentElement() {
  let className = 'quantity-and-button-wrapper';
  let element = document.querySelector('.' + className);
  const wrapper = document.createElement('div');
  wrapper.className = "ft1-qty-atb";
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
}
// Attach scroll event listener

document.addEventListener('DOMContentLoaded', addingTopStickyGallery());
document.addEventListener('DOMContentLoaded', addingParentElement());
window.addEventListener('scroll', handleScroll);
